import { useEffect } from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
// Helpers
import {
  EMPTY_EVENT_VENUE,
  EVENT_VENUE_FIELDS,
  EventVenueDraft,
} from 'helpers/ticketEvents';

type VenueFormValues = { venue: EventVenueDraft; venueSearch: string };

type EventVenueFields = {
  venue: EventVenueDraft;
  venueSearch: string;
  venueErrors: Partial<Record<keyof EventVenueDraft, FieldError>> | undefined;
};

/** Registers a form's venue draft and its search text, and reads them back. */
export const useEventVenueFields = (): EventVenueFields => {
  const { register, errors, watch } = useFormContext<VenueFormValues>();

  useEffect(() => {
    EVENT_VENUE_FIELDS.forEach((field) => register({ name: `venue.${field}` }));
    register({ name: 'venueSearch' });
  }, [register]);

  return {
    venue: watch('venue') || EMPTY_EVENT_VENUE,
    venueSearch: watch('venueSearch'),
    venueErrors: errors?.venue as EventVenueFields['venueErrors'],
  };
};
